import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { UpdateReceiptCheckItem } from "../../domain/usecases/update-receipt-check-item";
import { InvalidFieldError } from "../../validation/errors";
import { HttpClient } from "../protocols/http";

export class DbUpdateReceiptCheckItem implements UpdateReceiptCheckItem {
  constructor(
    private readonly url: string,
    private readonly httClient: HttpClient
  ) {}
  async update(id: number, batch: string): Promise<void> {
    const res = await this.httClient.request({
      url: this.url,
      method: "post",
      body: { id, batch },
    });

    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      if (res.statusCode === 401 || res.statusCode === 403) {
        throw new UnauthorizedError();
      }
      if (res.statusCode === 400) {
        throw new InvalidFieldError();
      }
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
